import React from "react";

import { Typography, TypographyProps } from "@portex-pro/ui-components";
import classNames from "classnames";
import { FontSizes, FontStyle, FontWeight, mapFontSizeToSize, mapFontWeightToWeight } from "types/styles";

export interface TextProps {
  /** x-small: 12, small: 14, medium: 16, large: 20, x-large: 24 */
  size: FontSizes;

  style?: FontStyle;

  /** light: 300, regular: 400, medium: 500, bold: 700 */
  weight?: FontWeight;
  typographyProps?: TypographyProps;
  required?: boolean;
}

const Text: React.FC<TextProps> = (props) => {
  const { children, size, style = "normal", weight = "regular", typographyProps, required = false } = props;

  return (
    <Typography
      {...typographyProps}
      style={{
        fontSize: mapFontSizeToSize[size],
        fontStyle: style,
        fontWeight: mapFontWeightToWeight[weight],
        ...typographyProps?.style,
      }}
      className={classNames(typographyProps?.className, { "after:content-['*'] after:text-red-500": required })}
    >
      {children}
    </Typography>
  );
};

export default Text;
